import React from "react";
import { Menu } from "lucide-react";
import { cn } from "../../lib/utils";
import { activeItemPath, type NavItem } from "./side-menu";

import { useTranslation } from "react-i18next";
interface BottomNavProps {
  items: NavItem[];
  activePath: string;
  onNavigate: (path: string) => void;
  onMenuClick?: () => void;
}

export const BottomNav = React.memo(function BottomNav({ items, activePath, onNavigate, onMenuClick }: BottomNavProps) {
  const { t } = useTranslation("common");
  const active = activeItemPath(items, activePath);
  const cols = items.length + (onMenuClick ? 1 : 0);

  return (
    <nav
      aria-label={t("bottomNav.navigationPrincipale")}
      className="fixed inset-x-0 bottom-0 z-30 border-t border-border bg-card/95 backdrop-blur md:hidden pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="grid" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
        {items.map((item) => {
          const isActive = item.path === active;
          return (
            <li key={item.path}>
              <button
                type="button"
                onClick={() => onNavigate(item.path)}
                aria-current={isActive ? "page" : undefined}
                className={cn(
                  "flex h-16 w-full flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors active:bg-accent",
                  isActive ? "text-foreground" : "text-muted-foreground"
                )}
              >
                <span className={cn("flex h-7 w-12 items-center justify-center rounded-full transition-colors", isActive && "bg-secondary")}>
                  <item.icon className="h-5 w-5" />
                </span>
                <span className="max-w-full truncate px-1">{t(item.shortLabelKey ?? item.labelKey)}</span>
              </button>
            </li>
          );
        })}
        {onMenuClick && (
          <li>
            <button
              type="button"
              onClick={onMenuClick}
              className="flex h-16 w-full flex-col items-center justify-center gap-1 text-[11px] font-medium text-muted-foreground active:bg-accent"
            >
              <span className="flex h-7 w-12 items-center justify-center">
                <Menu className="h-5 w-5" />
              </span>
              <span>{t("bottomNav.plus")}</span>
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
});
